module.exports = __webpack_public_path__ + "assets/img/hj-four.c25d6ba8.png";